import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/components/vss/data";

export default function Process() {
  return (
    <section
      id="process"
      className="relative py-28 sm:py-36 border-t border-slate-200 bg-slate-50/60"
      data-testid="process-section"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 lg:col-span-8">
            <div className="mb-3 font-mono-a text-[11px] uppercase tracking-[0.28em] text-teal-700">
              / 007 · The Manifesto
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-[1.05]">
              Four chapters,
              <br />
              <span className="font-serif-a italic font-normal text-slate-500">
                one accountable delivery.
              </span>
            </h2>
          </div>
        </div>

        <div className="flex flex-col">
          {PROCESS_STEPS.map((p, i) => (
            <motion.div
              key={p.idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ delay: i * 0.06, duration: 0.7, ease: "easeOut" }}
              className="group grid grid-cols-12 gap-6 py-10 sm:py-14 border-t border-slate-200 hover:bg-white/70 transition"
              data-testid={`process-step-${p.idx}`}
            >
              <div className="col-span-12 sm:col-span-3">
                <div className="font-display text-6xl sm:text-7xl lg:text-8xl font-extrabold text-slate-200 group-hover:text-teal-500 transition-colors leading-none tracking-tight">
                  {p.idx}
                </div>
              </div>
              <div className="col-span-12 sm:col-span-4">
                <div className="font-mono-a text-[10px] uppercase tracking-[0.28em] text-teal-700 mb-3">
                  Chapter {p.idx}
                </div>
                <h3 className="font-display text-2xl sm:text-3xl font-bold text-slate-900 leading-tight">
                  {p.title}
                </h3>
              </div>
              <div className="col-span-12 sm:col-span-5">
                <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
                  {p.body}
                </p>
              </div>
            </motion.div>
          ))}
          <div className="border-t border-slate-200" />
        </div>
      </div>
    </section>
  );
}
